export default {
  // 畫布類型
  multiCurrencyCanvas: "多幣種畫布",

  // 畫布名稱
  unnamedCanvas: "未命名畫布",

  // 案件名稱
  caseName: "案件：",

  // 搜索框
  searchPlaceholder: "搜索地址 / 哈希 / 調證用戶ID",

  // 按鈕
  startAnalysis: "開始分析",
  switchToOldVersion: "切到老版本",
  expandConfig: "擴展配置",
  refresh: "刷新",
  shareCanvas: "分享畫布",
  save: "保存",

  // 工具提示
  expandOrCollapseConfig: "展開或收起擴展配置項",

  // 下拉菜單
  surveyDataUpdate: "調證數據更新",
  labelUpdate: "標籤更新",
  noteUpdate: "備註更新",
  addressBalanceUpdate: "地址餘額更新",
  lastUpdate: "上次更新：",

  // 對話框
  dialogTitle: "提示",
  balanceUpdateMessage:
    "當前畫布地址共{count}個，更新餘額需要較長的時間，請耐心等待！",
  cancel: "取 消",
  confirm: "確 定",

  // 貨幣選項
  allCurrencies: "全部",
};
